import React, { Component } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { applyDataTable, destroyDataTable } from '../../../../../custom/dataTable';
import Edit from '../../../../../../assets/img/svg/edit.svg';
import Delete from '../../../../../../assets/img/svg/delete.svg';
import active from '../../../../../../assets/img/svg/active.svg';
import deactive from '../../../../../../assets/img/svg/deactive.svg';
import FilterIcon from '../../../../../../assets/img/svg/FilterIcon.svg'
import upload from '../../../../../../assets/img/svg/upload.svg';
import del from "../../../../../../assets/img/svg/Del.svg"
import Ship from '../../../../../../assets/img/svg/Ship.svg';
import View from "../../../../../../assets/img/svg/view.svg"
import download from "../../../../../../assets/img/svg/DownloadIcon.svg"
import Autocomplete from "react-autocomplete"
import { useNavigate } from "react-router-dom"
import Pagination from "../../../../../custom/Pagination";
import {
    TextField, FormControlLabel, Radio, Checkbox,
    Select, MenuItem, InputBase, Chip, Input, Button, InputAdornment,
    IconButton, FormHelperText, FormControl, RadioGroup
} from '@material-ui/core';
import $ from "jquery"
import withRouter from "../../../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../../../assets/jss/customStyle";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import { Tabs, Tab, AppBar, Box } from '@material-ui/core';
import Cancel from '../../../../../../assets/img/svg/cancel.svg';
import EasyEdit from 'react-easy-edit';
import axios from "axios";
import API from "../../../../../../_helpers/endpointService";
import { CssTextField, CssTextFieldLast, CssTextFieldRow, CssTextFieldTitle } from "../../../../../custom/textField"
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

class ListViewBD extends Component {
    constructor(props) {
        super(props);
        this.inputFile = React.createRef();
        this.state = {
            isMobile: false,
            count: "1",
            Block: 1,
            Loop: ['1'],
            BlockNo: false,
            value: 0,
            Docs: {},
            DelIndex: 0,
            index: 0,
            focusIndex: 0,
            filename: "",
            awsname: "",
            UserRole: '',
            autoFocus: false,
            autoFocus1: false,
            nameError: false,
            titleshow: true,
            showrow: false,
            blocknoError: false,
            BD_ListView: [],
            ProjectId: 0,
            searchData: {
                ProjectId: 0,
                Id: 0,
                PageNumber: 1,
                PageSize: 10,
            },
            addData: {
                Title: "",
                Id: 0,
                ProjectId: 0,
            },
            addBlock: {
                BlockNo: '',
                Comments: '',
                Id: 0,
                DrawingId: 0,
            },
            DrawingId: 0,
        }
    };

    AttachFiles = (e) => {
        this.inputFile.current.click();
    };
    AddNewRow = () => {
        this.state.Loop.push(parseInt(this.state.count + 1));
        this.state.count = parseInt(this.state.count + 1);
        this.state.Block += 1;
        this.setState({})
    };

    handleChangetab = (event, newValue) => {
        this.setState({
            value: newValue,
        })
    };

    hoverHeight = (e, i) => {
        let data = $("#BlockNo" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#BlockNo" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        let data1 = $("#Comments" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#Comments" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        this.state.HoverId = i.Id;
        if (data > data1) {
            this.state.Rows = data + 1;
        }
        else {
            this.state.Rows = data1 + 1;
        }
        this.setState({})
    }

    hoverHeight1 = (e, i) => {
        let data = $("#BlockNo" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#BlockNo" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        let data1 = $("#Comments" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#Comments" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        this.state.FocusId = i.Id;
        if (data > data1) {
            this.state.Rows1 = data + 1;
        }
        else {
            this.state.Rows1 = data1 + 1;
        }
        this.setState({})
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.state.ProjectId = parseInt(localStorage.getItem("DashId"))
        this.state.searchData.ProjectId = parseInt(localStorage.getItem("DashId"))
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"))
        if (this.state.addData.Title == "") {
            this.setState({
                titleshow: true
            })
        }
        else {
            this.setState({
                titleshow: false
            })
        }
        this.setState({})
        this.dataTable1(this.state.searchData, this.state.ProjectId);
        //this.Drawing(this.state.ProjectId)
        // applyDataTable("staffTable");

        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#BLOCK1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Disblockdiv1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Disblockdiv").addClass("d-none");
        $("#Disblockdiv").removeClass("d-block");
        $("#BDL").removeClass("active-color");
        $("#BDT").removeClass("fw-bolder");
    }
    dataTable = (data, id) => {
        let apiUrl = API.BLOCKPLAN + '?projectId=' + id + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.setState({
                        BD_ListView: response.data,
                    })
                    //this.props.dispatch({ type: "BD_LISTVIEW", data: response.data });
                    if (response.data.Drawing.length > 0) {
                        this.setState({
                            BD_ListView: [],
                        })
                        response.data.Drawing[0].Blocks.sort((a, b) => {
                            return a.Id - b.Id;
                        });
                        this.setState({
                            BD_ListView: response.data,
                        })
                        this.state.addData.Id = response.data.Drawing[0].Id
                        this.state.addData.Title = response.data.Drawing[0].Title
                        if (this.state.addData.Title == "") {
                            this.setState({
                                titleshow: true
                            })
                        }
                        else {
                            this.setState({
                                titleshow: false
                            })
                        }
                        this.setState({ index: this.state.BD_ListView.Drawing[0].Blocks.length + 1 })
                        localStorage.setItem("BlockId", response.data.Drawing[0].Id)

                        if (response.data.Drawing[0].Drawing) {
                            this.state.Docs = {
                                FileName: response.data.Drawing[0].Drawing.FileName,
                                ObjectKey: response.data.Drawing[0].Drawing.ObjectKey,
                                AwsFolderName: response.data.Drawing[0].Drawing.AwsFolderName,
                                AwsUniqueFileName: response.data.Drawing[0].Drawing.AwsUniqueFileName,
                                FileExtention: response.data.Drawing[0].Drawing.FileExtention,
                                FileUrl: response.data.Drawing[0].Drawing.FileUrl,
                                FileSize: response.data.Drawing[0].Drawing.FileSize,
                            }

                            this.state.BD_ListView.Drawing[0].Blocks.push({
                                Id: 0,
                                ProjectId: this.state.ProjectId,
                                DrawingId: response.data.Drawing[0].Id,
                                BlockNo: "",
                                Comments: "",
                            })
                            this.state.DrawingId = response.data.Drawing[0].Id === 0 ? this.state.DrawingId : response.data.Drawing[0].Id;
                            this.setState({})
                        }
                        this.props.dispatch({ type: "SHOW_LOADER", data: false })
                    }
                }
                else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }

            })
            .catch((error) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })

            });
    }
    dataTable1 = (data, id) => {
        let apiUrl = API.BLOCKPLAN + '?projectId=' + id + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {

                    // this.props.dispatch({ type: "BD_LISTVIEW", data: response.data });
                    if (response.data.Drawing.length > 0) {
                        this.setState({
                            BD_ListView: [],
                        })
                        response.data.Drawing[0].Blocks.sort((a, b) => {
                            return a.Id - b.Id;
                        });
                        this.setState({
                            BD_ListView: response.data,
                        })
                        this.setState({ index: this.state.BD_ListView.Drawing[0].Blocks.length + 1 })
                        this.state.addData.Id = response.data.Drawing[0].Id
                        this.state.addData.Title = response.data.Drawing[0].Title
                        if (this.state.addData.Title == "") {
                            this.setState({
                                titleshow: true
                            })
                        }
                        else {
                            this.setState({
                                titleshow: false
                            })
                        }
                        localStorage.setItem("BlockId", response.data.Drawing[0].Id)
                        if (response.data.Drawing[0].Drawing) {
                            this.state.Docs = {
                                FileName: response.data.Drawing[0].Drawing.FileName,
                                ObjectKey: response.data.Drawing[0].Drawing.ObjectKey,
                                AwsFolderName: response.data.Drawing[0].Drawing.AwsFolderName,
                                AwsUniqueFileName: response.data.Drawing[0].Drawing.AwsUniqueFileName,
                                FileExtention: response.data.Drawing[0].Drawing.FileExtention,
                                FileUrl: response.data.Drawing[0].Drawing.FileUrl,
                                FileSize: response.data.Drawing[0].Drawing.FileSize,
                            }
                            this.state.DrawingId = response.data.Drawing[0].Id;
                            this.setState({})
                            if (this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor") {
                                this.state.BD_ListView.Drawing[0].Blocks.push({
                                    Id: 0,
                                    ProjectId: this.state.ProjectId,
                                    DrawingId: this.state.DrawingId,
                                    BlockNo: "",
                                    Comments: "",
                                })
                            }
                        }
                    }
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
                else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }

            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

            });
    }
    UploadFile = (e) => {
        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                FileName: a.name,
                Filesize: a.size,
                fdata: a,
                base64: await this.toBase64(a),
            }
            this.state.Docs = upload
            this.setState({})
            let formData = new FormData()
            formData.append("drawing", this.state.Docs.fdata)
            this.AddDrawing(this.state.addData.Id, formData)
        })


    };
    AddDrawing = (id, formData) => {
        let apiUrl = API.BLOCK + 'DismantlingPlan/' + id + '/BlockPlan'
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: formData,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.dataTable(this.state.searchData, this.state.ProjectId);
                } else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {
                }
            });
    }
    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }

        // this.state.BD_ListView = this.props.BD_ListView;
        // this.setState({})
    };
    resize1 = () => {
        $("#BLOCK1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Disblockdiv1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Disblockdiv").removeClass("d-none");
        $("#Disblockdiv").addClass("d-block");
        $("#BDL").addClass("active-color");
        $("#BDT").addClass("fw-bolder");
    }
    sidebar = () => {
        this.props.navigate("/sidebar");
    }
    AddNew = () => {
        this.props.navigate("/dismantlingplan/blockdivision/addnew")
    };

    EditPage = () => {
        this.props.navigate("/dismantlingplan/blockdivision/edit")
    };

    ViewPage = () => {
        this.props.navigate("/dismantlingplan/blockdivision/view")
    };

    handleFocusActChange = (e, str, val) => {
        this.setState({ focusIndex: str.Id })
        if (str.Id != 0 && e.target.value.trim().length > 0) {
            document.getElementById('BlockNo' + val).selectionStart = e.target.value.trim().length;
            document.getElementById('BlockNo' + val).focus()
        }
    };

    handleFocusDescription = (e, str, val) => {
        if (str.Id == 0 && e.target.value.trim().length > 0) {
            document.getElementById('Comments').selectionStart = e.target.value.trim().length;
            document.getElementById('Comments').focus()
        }
    }

    handleInputChangeBlock1 = (e, index, val, Id, Block) => {
        this.setState({ index: this.state.BD_ListView.Drawing[0].Blocks.length })

        if (val == "Comments") {
            this.state.commentsShow = true;
            this.setState({})
            this.state.BD_ListView.Drawing[0].Blocks[index].Comments = e.target.value;
            if (Id == 0 && e.target.value.trim() != "") {
                this.state.nameError = true;
                this.setState({})
            }
            if (Id == 0 && e.target.value.trim() == "") {
                this.state.nameError = false;
                this.setState({})
            }
            this.setState({})
        }
        if (val == "BlockNo") {
            this.state.BD_ListView.Drawing[0].Blocks[index].BlockNo = e.target.value;
            this.state.commentsShow = false;
            this.setState({})
            if (this.state.BD_ListView.Drawing[0].Blocks[index].Id == 0 && e.target.value.trim() != "") {
                this.setState({
                    showrow: true,
                    autoFocus: true
                })
            }
            if (this.state.BD_ListView.Drawing[0].Blocks[index].BlockNo == "") {
                this.setState({
                    blocknoError: true,
                })
            }
            if (Id == 0 && e.target.value.length == 1 && e.target.value.trim() != "") {
                this.state.BD_ListView.Drawing[0].Blocks[index].BlockNo = e.target.value.trim();
                this.state.BD_ListView.Drawing[0].Blocks[index].ProjectId = this.state.ProjectId;

                this.setState({})
                this.postApi(this.state.BD_ListView.Drawing[0].Blocks[index])
                this.state.showrow = true;
                this.state.focusIndex = Id;
                document.getElementById("BlockNo" + Id).focus();
            }
            if (e.target.value.trim() == "") {
                this.state.focusIndex = Id;
                document.getElementById("BlockNo" + Id).focus();
                this.state.NameError = true;
                this.setState({})
            }
        }
    };

    handleInputChangeBlock = (e, index, val, Id) => {
        this.state.BD_ListView.Drawing[0].Blocks[index].DrawingId = parseInt(localStorage.getItem("BlockId"))
        // this.state.addBlock[val] = e.target.value.trim();
        this.state.commentsShow = false;
        this.state.addBlock.DrawingId = parseInt(localStorage.getItem("BlockId"))
        if (val == "Comments") {
            this.state.BD_ListView.Drawing[0].Blocks[index].Comments = e.target.value.trim();
            this.state.BD_ListView.Drawing[0].Blocks[index].ProjectId = this.state.ProjectId;
            this.setState({})
            this.putApi(this.state.BD_ListView.Drawing[0].Blocks[index], this.state.BD_ListView.Drawing[0].Blocks[index].Id)
        }
        if (val == "BlockNo") {
            if (e.target.value.trim() == "") {
                let ids = Id.Id
                localStorage.setItem("DblockId", ids)
                this.Delete()
            }
            else {
                this.state.BD_ListView.Drawing[0].Blocks[index].Block = e.target.value.trim();
                this.state.BD_ListView.Drawing[0].Blocks[index].BlockNo = e.target.value.trim();
                this.state.BD_ListView.Drawing[0].Blocks[index].ProjectId = this.state.ProjectId;
                this.setState({})
                this.putApi(this.state.BD_ListView.Drawing[0].Blocks[index], this.state.BD_ListView.Drawing[0].Blocks[index].Id)
            }
        }
        this.setState({})
        this.setState({ FocusId1: 0,focusIndex: 0 })
        // this.state.BD_ListView.Drawing[0].Blocks[index].DrawingId = parseInt(localStorage.getItem("BlockId"))
    }

    posthandleInputChangeBlock = (e, index, val, Id, Block) => {
        this.state.BD_ListView.Drawing[0].Blocks[index].DrawingId = parseInt(localStorage.getItem("BlockId"))
        this.state.addBlock[val] = e.target.value.trim();
        this.state.addBlock.DrawingId = parseInt(localStorage.getItem("BlockId"))
        if (val == "Comments") {
            this.state.BD_ListView.Drawing[0].Blocks[index].Comments = e.target.value.trim();
            if (Id == 0 && Block == "" && e.target.value == "") {
                this.state.nameError = false;
            }
        }
        if (val == "BlockNo") {
            this.state.BD_ListView.Drawing[0].Blocks[index].BlockNo = e.target.value.trim();
            if (e.target.value.trim() == "") {
                this.state.showrow = false;
                this.state.nameError = true;
                this.state.BD_ListView.Drawing[0].Blocks[index].Comments = "";
            }
            if (Block.trim() == "" && e.target.value.trim() == "") {
                this.state.nameError = false;
            }
            if (e.target.value.trim() != "") {
                this.state.BD_ListView.Drawing[0].Blocks[index].BlockNo = e.target.value.trim();
                this.putApi(this.state.BD_ListView.Drawing[0].Blocks[index], this.state.BD_ListView.Drawing[0].Blocks[index].Id)
            }
        }
        this.setState({})
    }

    handleFocusChange = (e, str, val) => {
        if (e.target.value.trim().length > 0) {
            document.getElementById('BlockNo').selectionStart = e.target.value.length;
            document.getElementById('BlockNo').focus()
        }
    }

    postApi = (data) => {
        let apiUrl = API.BLOCKPLAN;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    // this.dataTable(this.state.searchData, this.state.ProjectId);
                    this.setState({
                        blocknoError: true,
                        showrow: false,
                        nameError: false,
                        autoFocus: false,
                    })
                    this.state.BD_ListView.Drawing[0].Blocks.map((i) => (
                        i.Id == 0 ? i.Id = response.data : <></>
                    ))
                    // let id = this.state.BD_ListView.Drawing[0].Blocks.filter((i) => i.Id == 0)
                    this.state.BD_ListView.Drawing[0].Blocks.push({
                        Id: 0,
                        DrawingId: this.state.DrawingId,
                        BlockNo: "",
                        Comments: "",
                    })
                    // }
                    this.state.focusIndex = response.data;
                    document.getElementById("BlockNo" + response.data).focus();
                    this.setState({})
                    this.state.BD_ListView.Drawing[0].Blocks.sort((a, b) => {
                        return a.Id - b.Id;
                    });
                    this.setState({})
                    //this.props.navigate("/dismantlingplan/blockdivision")
                } else {
                }
            })
            .catch((error) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };
    putApi = (data, id) => {

        let apiUrl = API.BLOCK + 'DismantlingPlan/' + id + '/BlockPlan'
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    // this.dataTable(this.state.searchData, this.state.ProjectId);
                    //this.props.navigate("/dismantlingplan/blockdivision")
                } else {
                }
            })
            .catch((error) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {
                }
            });
    };
    handleInputChange = (e) => {
        if (this.state.addData.Id == 0) {
            if (this.state.addData.Title != "") {
                this.state.titleshow = false;
                this.state.addData.Title = e.target.value.trim();
                this.PostTitle(this.state.addData)
            }
            else {
                this.setState({
                    titleshow: true
                })
            }
        }
        else {
            if (e.target.value.trim() != '') {
                this.state.titleshow = false;
                this.state.addData.Title = e.target.value.trim();
                this.setState({})
                this.putTitle(this.state.addData, this.state.addData.Id)
            }
            else {
                this.state.addData.Title = e.target.value.trim();
                this.state.titleshow = true
                this.setState({})
                this.putTitle(this.state.addData, this.state.addData.Id)

            }
        }
        this.setState({})
    }
    handleInputChange1 = (e) => {
        this.state.addData.Title = e.target.value;
        this.setState({})
    }
    PostTitle = (data) => {
        let apiUrl = API.BLOCKPLAN + '/Title';
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.dataTable(this.state.searchData, this.state.ProjectId);
                } else {
                }
            })
            .catch((error) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };
    putTitle = (data, id) => {
        let apiUrl = API.BLOCKPLAN + '/Title?id=' + id;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.dataTable(this.state.searchData, this.state.ProjectId);
                } else {
                }
            })
            .catch((error) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };
    cancel = () => { }

    OpenPopup = (filename, awsname, id) => {
        this.state.filename = filename;
        this.state.awsname = awsname;
        // this.state.Id = id;
        this.setState({})
        window.$("#deletepopup").modal("show");
    }

    DeleteItem = () => {
        if (this.state.DelIndex == 0) {
            if (this.state.Docs.AwsUniqueFileName == this.state.awsname && this.state.awsname != undefined) {
                this.deletePhoto(this.state.addData.Id, this.state.awsname)
            }
        }
        window.$("#deletepopup").modal("hide");
        //this.dataTable(this.state.searchData, this.state.ProjectId);
    }
    deletePhoto = (id, filename) => {
        let apiUrl = API.BLOCK + 'DismantlingPlan/id/Drawing?id=' + id + '&filename=' + filename;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "DELETE",
            url: apiUrl,

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.dataTable(this.state.searchData, this.state.ProjectId);
                    this.state.Docs = {}
                    this.setState({})
                    this.props.navigate(`/dismantlingplan/blockdivision`)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };
    DeleteBlocks = (id) => {
        let ids = id
        localStorage.setItem("DblockId", ids)
        window.$("#deletepopup1").modal("show")
    }
    Delete = () => {
        window.$("#deletepopup1").modal("hide");
        let id = parseInt(localStorage.getItem("DblockId"))
        let ids = "";
        ids = "ids=" + id
        let apiUrl = API.BLOCK + 'DismantlingPlan/ids?' + ids;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "delete",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.dataTable(this.state.searchData, this.state.ProjectId);
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                }
            });
    }
    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"BLOCK" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="BLOCK" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>Block Division</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ?
                        <table className="dataTable border-top" width="100%">
                            <tbody>
                                <tr><>

                                </></tr>
                            </tbody>
                        </table>
                        :
                        <></>}
                    <div>
                        <div className="row mt-4">
                            <div>
                                <div className="row" style={{ margin: this.state.isMobile ? "0" : "5px" }}>
                                    <div className="">
                                        {this.state.isMobile ? <></> : <h6 className="">Block Division</h6>}
                                    </div>
                                    <div className={this.state.isMobile ? "row px-0 mx-0 mt-n4" : "row px-0 mx-0"}>
                                        {this.state.titleshow ? <>
                                            <div className="mt-3 pt-1" style={{ width: '68px' }}>
                                                <span className="mr-3 spandoc-thead">Title&nbsp;:</span>
                                            </div>
                                            <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-3 mt-3">
                                                {this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? <>
                                                    <CssTextFieldLast
                                                        multiline
                                                        fullWidth
                                                        variant="outlined"
                                                        type="text"
                                                        onChange={(e) => this.handleInputChange1(e)}
                                                        onBlur={(e) => this.handleInputChange(e)}
                                                        value={this.state.addData.Title}
                                                        InputProps={{
                                                            className: `border-radius padding-space spandoc-tbody  ${classes.inputfieldAlign}`
                                                        }} /></> : <>
                                                    <CssTextFieldLast
                                                        multiline
                                                        fullWidth
                                                        variant="outlined"
                                                        type="text"

                                                        disabled
                                                        value={this.state.addData.Title}
                                                        InputProps={{
                                                            className: `border-radius padding-space spandoc-tbody spanTopBar ${classes.inputfieldAlign}`
                                                        }} /></>}


                                            </div>
                                        </> : <>
                                            <div className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 mt-4 px-1">
                                                <span className="fw-bold">
                                                    {this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? <>
                                                        <CssTextField
                                                            multiline
                                                            fullWidth
                                                            variant="outlined"
                                                            type="text"
                                                            onChange={(e) => this.handleInputChange1(e)}
                                                            onBlur={(e) => this.handleInputChange(e)}
                                                            value={this.state.addData.Title}
                                                            InputProps={{
                                                                className: `border-radius padding-space spandoc-tbody spanTopBar ${classes.inputfieldAlign}`
                                                            }} />
                                                    </>
                                                        :
                                                        <>
                                                            <CssTextFieldTitle
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                disabled
                                                                value={this.state.addData.Title}
                                                                InputProps={{
                                                                    className: `border-radius padding-space spandoc-tbody spanTopBar ${classes.inputfieldAlign}`
                                                                }} /></>
                                                    }
                                                </span>
                                            </div>
                                        </>}
                                        {
                                            Object.keys(this.state.Docs).length == 0 ? <>
                                                <div className="row mt-3">
                                                    <div className="d-flex">
                                                        <span className="pr-2 mr-1 spandoc-thead">Drawing&nbsp;:</span>
                                                        <button className="pending-button" style={{ marginRight: '5px' }}><h1 style={{ fontSize: '11px' }}>PENDING</h1></button>
                                                        {this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? <>
                                                            <img src={upload} className="pl-2 mr-1" style={{ width: 23, height: 23, marginTop: '-2px', opacity: this.state.titleshow == false ? '' : '0.5' }} />
                                                            <button className={`${classes.button} pl-0`} disabled={this.state.titleshow == false ? false : true} onChange={(e) => this.UploadFile(e)} onClick={this.AttachFiles}><span className="cursorponitor">Upload</span></button>
                                                        </> : <>

                                                        </>}
                                                        <input
                                                            type="file"
                                                            hidden
                                                            onChange={(e) => this.UploadFile(e)}
                                                            ref={this.inputFile}
                                                        />
                                                    </div>
                                                </div></> : <>
                                                <div>
                                                    <div className="text-right pb-1">
                                                        {this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? <>
                                                            <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(this.state.Docs.FileName, this.state.Docs.AwsUniqueFileName, this.state.Docs.Id) }} />
                                                        </> : <></>}
                                                    </div>
                                                    <div className="col-12 px-0 text-row pb-2 text-center pt-2">
                                                        <img className="img-fluid px-2 " src={this.state.Docs.FileUrl}></img>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                                <div className="row" style={{ margin: this.state.isMobile ? "0px" : "5px" }}>
                                    <div className="mt-2">
                                        <div className="table-responsive mb-5" style={{ width: "100%" }}>
                                            <table className="table table-borderless border-top border-bottom border-left border-right" >
                                                <thead>
                                                    <tr className="table-active">
                                                        <th className="border-top border-left border-right text-center" width="3%" style={{ minWidth: '3%', maxWidth: '3%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>S.No</span></th>
                                                        <th className="border-top border-right" width="15%" style={{ minWidth: '100px', maxWidth: '15%' }}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Block No</span></th>
                                                        <th className="border-top border-right" width="79%" style={{ minWidth: '250px', maxWidth: '79%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Comments</span></th>
                                                        {this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? <>
                                                            <th className="border-top border-right" width="3%" style={{ minWidth: '3%', maxWidth: '3%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                                        </> : <></>}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.BD_ListView?.Drawing && this.state.BD_ListView?.Drawing.map((i, index) => (
                                                        i.Blocks && i.Blocks.map((i, index) => (
                                                            i.Id != 0 ? <>
                                                                {this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? <>
                                                                    < tr className="border-top" >
                                                                        <td className="border-right border-left align-middle text-center spandoc-td">{index + 1}</td>
                                                                        <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left spandoc-td`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                                            {/* <div className={(this.state.HoverId == i.Id || this.state.focusIndex == i.Id) ? "border-top border-bottom border-left border-right" : ""}> */}
                                                                            <div className={(this.state.HoverId == i.Id || this.state.focusIndex == i.Id) ? "border-bg" : "border-bg-none"}>
                                                                                {/* {i.BlockNo.trim() == "" ?
                                                                                    <CssTextFieldLast
                                                                                        multiline
                                                                                        fullWidth
                                                                                        variant="outlined"
                                                                                        type="text"
                                                                                        id={"BlockNo" + i.Id}
                                                                                        minRows={this.state.HoverId == i.Id ? this.state.Rows : 1}
                                                                                        autoFocus={this.state.focusIndex == i.Id ? true : false}
                                                                                        onFocus={(e) => this.handleFocusActChange(e, i, i.Id)}
                                                                                        onChange={(e) => this.handleInputChangeBlock1(e, index, 'BlockNo', i.Id)}
                                                                                        onBlur={(e) => this.handleInputChangeBlock(e, index, 'BlockNo', i)}
                                                                                        value={i.BlockNo}
                                                                                        InputProps={{
                                                                                            className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                                        }} /> : */}
                                                                                    <CssTextFieldRow
                                                                                        multiline
                                                                                        fullWidth
                                                                                        variant="outlined"
                                                                                        type="text"
                                                                                        autoFocus={this.state.focusIndex == i.Id ? true : false}
                                                                                        id={"BlockNo" + i.Id}
                                                                                        onMouseEnter={(e) => this.setState({ HoverId: i.Id })}
                                                                                        onMouseLeave={(e) => this.setState({ HoverId: 0 })}
                                                                                        style={{ height: $("#BlockNo" + i.Id).outerHeight() > $("#Comments" + i.Id).outerHeight() ? $("#BlockNo" + i.Id).outerHeight() + 13 : $("#Comments" + i.Id).outerHeight() + 13, marginTop: "-3px" }}
                                                                                        onChange={(e) => this.handleInputChangeBlock1(e, index, 'BlockNo', i.Id)}
                                                                                        onBlur={(e) => this.handleInputChangeBlock(e, index, 'BlockNo', i)}
                                                                                        onFocus={(e) => this.handleFocusActChange(e, i, i.Id)}
                                                                                        onFocusOut={(e) => this.setState({ focusIndex: 0 })}
                                                                                        value={i.BlockNo}
                                                                                        InputProps={{
                                                                                            className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                                        }} />
                                                                                {/* } */}
                                                                                {(i.BlockNo.trim() == "") ?
                                                                                    <span className="pt-5" style={{ color: '#DD0000' }}>Block No. is required</span> : <></>}
                                                                            </div>
                                                                        </td>
                                                                        <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left spandoc-td`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                                            {/* <div className={(this.state.HoverId1 == i.Id || this.state.FocusId1 == i.Id) ? "border-top border-bottom border-left border-right" : ""}> */}
                                                                            <div className={(this.state.HoverId1 == i.Id || this.state.FocusId1 == i.Id) ? "border-bg" : "border-bg-none"}>
                                                                                <CssTextFieldRow
                                                                                    multiline
                                                                                    fullWidth
                                                                                    variant="outlined"
                                                                                    type="text"
                                                                                    // onFocus={(e) => this.handleFocusDescription(e, i, i.Id)}
                                                                                    id={"Comments" + i.Id}
                                                                                    onMouseEnter={(e) => this.setState({ HoverId1: i.Id })}
                                                                                    onMouseLeave={(e) => this.setState({ HoverId1: 0 })}
                                                                                    onFocus={(e) => this.setState({ FocusId1: i.Id })}
                                                                                    style={{ height: $("#BlockNo" + i.Id).outerHeight() > $("#Comments" + i.Id).outerHeight() ? $("#BlockNo" + i.Id).outerHeight() + 13 : $("#Comments" + i.Id).outerHeight() + 13, marginTop: "-3px" }}
                                                                                    onChange={(e) => this.handleInputChangeBlock1(e, index, 'Comments')}
                                                                                    onBlur={(e) => this.handleInputChangeBlock(e, index, 'Comments', i)}
                                                                                    value={i.Comments}
                                                                                    InputProps={{
                                                                                        className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                                    }} />
                                                                                {/* {this.state.commentsShow == true ? <>
                                                                            <label className="float-end" style={{ opacity: '0.5' }}>{this.state.addData?.Comments?.length == undefined ? 500 - 0 : 500 - this.state.addData?.Comments?.length}/500 Characters left</label>
                                                                        </> :
                                                                            <> </>
                                                                        } */}
                                                                            </div>
                                                                        </td>
                                                                        {this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? <>
                                                                            <td className="border-right align-middle text-center spandoc-td">
                                                                                {i.Id == 0 ? <></> : <>
                                                                                    <img src={Delete} className="cursorPointer" onClick={() => this.DeleteBlocks(i.Id)}></img>
                                                                                </>}
                                                                            </td>
                                                                        </> : <></>}
                                                                    </tr>
                                                                </> : <>
                                                                    < tr className="border-top" >
                                                                        <td className="border-right border-left align-middle text-center spandoc-td">{index + 1}</td>
                                                                        <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left spandoc-td`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                                            {i.BlockNo.trim() == "" ?
                                                                                <CssTextFieldLast
                                                                                    multiline
                                                                                    fullWidth
                                                                                    variant="outlined"
                                                                                    type="text"
                                                                                    disabled
                                                                                    // id={"BlockNo" + i.Id}
                                                                                    // autoFocus={this.state.focusIndex == i.Id ? true : false}
                                                                                    // onFocus={(e) => this.handleFocusActChange(e, i, i.Id)}
                                                                                    // onChange={(e) => this.handleInputChangeBlock1(e, index, 'BlockNo', i.Id)}
                                                                                    // onBlur={(e) => this.handleInputChangeBlock(e, index, 'BlockNo', i)}
                                                                                    value={i.BlockNo}
                                                                                    InputProps={{
                                                                                        className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                                    }} /> :
                                                                                <CssTextField
                                                                                    multiline
                                                                                    disabled
                                                                                    fullWidth
                                                                                    variant="outlined"
                                                                                    type="text"
                                                                                    // autoFocus={this.state.focusIndex == i.Id ? true : false}
                                                                                    // id={"BlockNo" + i.Id}
                                                                                    // onChange={(e) => this.handleInputChangeBlock1(e, index, 'BlockNo', i.Id)}
                                                                                    // onBlur={(e) => this.handleInputChangeBlock(e, index, 'BlockNo', i)}
                                                                                    // onFocus={(e) => this.handleFocusActChange(e, i, i.Id)}
                                                                                    value={i.BlockNo}
                                                                                    InputProps={{
                                                                                        className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                                    }} />
                                                                            }

                                                                        </td>
                                                                        <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left spandoc-td`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                                            <CssTextField
                                                                                multiline
                                                                                fullWidth
                                                                                disabled
                                                                                variant="outlined"
                                                                                type="text"
                                                                                // onFocus={(e) => this.handleFocusDescription(e, i, i.Id)}
                                                                                // id={"Comments" + i.Id}
                                                                                // onChange={(e) => this.handleInputChangeBlock1(e, index, 'Comments')}
                                                                                // onBlur={(e) => this.handleInputChangeBlock(e, index, 'Comments', i)}
                                                                                value={i.Comments}
                                                                                InputProps={{
                                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                                }} />
                                                                            {/* {this.state.commentsShow == true ? <>
                                                                            <label className="float-end" style={{ opacity: '0.5' }}>{this.state.addData?.Comments?.length == undefined ? 500 - 0 : 500 - this.state.addData?.Comments?.length}/500 Characters left</label>
                                                                        </> :
                                                                            <> </>
                                                                        } */}
                                                                        </td>
                                                                        {this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? <>
                                                                            <td className="border-right align-middle text-center spandoc-td">
                                                                                {i.Id == 0 ? <></> : <>
                                                                                    <button className={`${classes.button} `} disabled="true">
                                                                                        <img src={Delete} className="cursorPointer" style={{ opacity: '0.5' }}></img>
                                                                                    </button> </>}
                                                                            </td>
                                                                        </> : <></>}
                                                                    </tr></>}
                                                            </>
                                                                :
                                                                <></>
                                                        ))
                                                    ))}
                                                    {this.state.BD_ListView?.Drawing && this.state.BD_ListView?.Drawing.map((i, index) => (
                                                        i.Blocks && i.Blocks.map((i, index) => (
                                                            i.Id == 0 ?
                                                                <tr className="border-top">
                                                                    <td className="border-right border-left align-middle text-center spandoc-td">{index + 1}</td>
                                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left spandoc-td`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                                        {(i.BlockNo.trim() == "") ?
                                                                            <CssTextFieldLast
                                                                                multiline
                                                                                fullWidth
                                                                                variant="outlined"
                                                                                type="text"
                                                                                id="BlockNo"
                                                                                onFocus={(e) => this.handleFocusChange(e, i, 'BlockNo')}
                                                                                autoFocus={this.state.autoFocus}
                                                                                onChange={(e) => this.handleInputChangeBlock1(e, index, 'BlockNo', i.Id, i.BlockNo)}
                                                                                onBlur={(e) => this.posthandleInputChangeBlock(e, index, 'BlockNo', i.Id, i.BlockNo)}
                                                                                value={i.BlockNo}
                                                                                InputProps={{
                                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                                }} /> :
                                                                            <CssTextField
                                                                                multiline
                                                                                fullWidth
                                                                                variant="outlined"
                                                                                type="text"
                                                                                id="BlockNo"
                                                                                onFocus={(e) => this.handleFocusChange(e, i, 'BlockNo')}
                                                                                autoFocus={this.state.autoFocus}
                                                                                onChange={(e) => this.handleInputChangeBlock1(e, index, 'BlockNo', i.Id, i.BlockNo)}
                                                                                onBlur={(e) => this.posthandleInputChangeBlock(e, index, 'BlockNo', i.Id, i.BlockNo)}
                                                                                value={i.BlockNo}
                                                                                InputProps={{
                                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                                }} />
                                                                        }
                                                                        {(i.BlockNo.trim() == "" && i.Comments.trim() != "") ?
                                                                            <span className="pt-5" style={{ color: '#DD0000' }}>Block No. is required</span> : <></>}
                                                                    </td>
                                                                    <td className="border-right spandoc-td" style={{ minWidth: '79%', maxWidth: '79%' }}>
                                                                        {/* {(i.Comments == "") ?
                                                                            <CssTextFieldLast
                                                                                multiline
                                                                                fullWidth
                                                                                variant="outlined"
                                                                                type="text"
                                                                                id="Comments"
                                                                                onFocus={(e) => this.handleFocusDescription(e, index, 'Comments', i.Id)}
                                                                                onChange={(e) => this.handleInputChangeBlock1(e, index, 'Comments', i.Id)}
                                                                                onBlur={(e) => this.posthandleInputChangeBlock(e, index, 'Comments', i.Id)}
                                                                                value={i.Comments}
                                                                                InputProps={{
                                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                                }} /> : */}
                                                                        <CssTextFieldLast
                                                                            multiline
                                                                            fullWidth
                                                                            variant="outlined"
                                                                            type="text"
                                                                            id='Comments'
                                                                            onFocus={(e) => this.handleFocusDescription(e, index, 'Comments', i.Id)}
                                                                            onChange={(e) => this.handleInputChangeBlock1(e, index, 'Comments', i.Id)}
                                                                            onBlur={(e) => this.posthandleInputChangeBlock(e, index, 'Comments', i.Id)}
                                                                            value={i.Comments}
                                                                            InputProps={{
                                                                                className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                            }} />
                                                                        {/* } */}
                                                                        {/* {this.state.commentsShow == true ? <>
                                                                            <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Comments?.length == undefined ? 500 - 0 : 500 - this.state.addData?.Comments?.length}/500 Characters left</label>
                                                                        </> :
                                                                            <> </>
                                                                        } */}

                                                                    </td>
                                                                    <td className="border-right align-middle text-center spandoc-td">
                                                                        {(i.Id == 0 && i.BlockNo.trim() == "") ? <></> : <>
                                                                            <img src={Delete} className="cursorPointer" onClick={() => this.DeleteBlocks(i.Id)}></img>
                                                                        </>}
                                                                    </td>
                                                                </tr>
                                                                :
                                                                <></>
                                                        ))
                                                    ))}
                                                    {this.state.showrow ?
                                                        <tr className="border-top">
                                                            <td className="align-middle text-center border-right spandoc-td">
                                                                {this.state.index + 1}
                                                            </td>
                                                            <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left spandoc-td`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                                <CssTextFieldLast
                                                                    type="text"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    multiline
                                                                    size="small"
                                                                    InputProps={{
                                                                        className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left spandoc-td`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                                <CssTextFieldLast
                                                                    type="text"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    multiline
                                                                    size="small"
                                                                    InputProps={{
                                                                        className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="align-middle text-center border-right spandoc-td">
                                                            </td>
                                                        </tr> : ""}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>

                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>

                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItem}><span className="" >Delete</span></button>
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} id="closemodal" onClick={() => window.$("#deletepopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup1" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>

                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>

                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.Delete}><span className="" >Delete</span></button>
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} id="closemodal1" onClick={() => window.$("#deletepopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        BD_ListView: state.BlockDivisionReducer.BD_ListView || [],

    };
}

ListViewBD.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ListViewBD))
);


